import { Component, inject } from '@angular/core';
import { SharedModule } from '../../shared.module';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormControl } from '@angular/forms';

@Component({
  selector: 'ngb-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrl: './confirm-dialog.component.scss',
  imports: [
    SharedModule
  ],
})
export class ConfirmDialogComponent {

  
  readonly dialogRef : MatDialogRef<ConfirmDialogComponent> = inject(MatDialogRef<ConfirmDialogComponent>);
  readonly data = inject<{ title: string; message: string ,notes?:boolean}>(MAT_DIALOG_DATA);
  private readonly _fb :FormBuilder = inject(FormBuilder);

  notes:FormControl = this._fb.control(null);

onConfirm(): void {
  this.dialogRef.close({
    confirmed: true,
    notes: this.notes.value
  });
}

  onCancel(): void {
    this.dialogRef.close(false);
  }
}
